import { render, staticRenderFns } from "./FreelanceVatInfoSelector.vue?vue&type=template&id=228b3222"
import script from "./FreelanceVatInfoSelector.vue?vue&type=script&lang=ts"
export * from "./FreelanceVatInfoSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports